<template>
  <div class="getTopic">
      <div class="getTopicbox">
          <!--我的订单列表-->
          <div class='box' v-if="list.length>0">
              <p class='title'>等待付款</p>
              <div class="center">
                <div class='left'><img src="../../assets/img/champion.png" alt=""></div>
                <div class="right">
                  <div class='rightbox'>
                    <div class='rightTitle'>小米（MI）小米电视4S 55/65英寸络液晶平板电视全部…pro超清人络液晶平板电视全部…工智能网</div>
                    <div class='rightText'>灰色 全面屏E65S 2G+32G 内置小爱功能灰色内置小爱功能灰色内置小爱功能灰色内置小爱功能灰色内置小爱功能灰色全面屏E65S 2G+32G 内置小爱功能</div>
                  </div>
                  <div class='numberbox'>
                    <span class='number'>共计1件商品</span>
                    <span class="price">合计<font>¥3199.00</font></span>
                  </div>
                </div>
              </div>
              <div class='btnBox'>
                  <span v-show="a=='1'">取消订单</span>
                  <span v-show="a=='1'" class="payment">付款</span>
                  <span v-show="a=='2'">退款</span>
                  <span v-show="a=='2' || b=='1'">更换地址</span>
                  <span v-show="a=='3'">查看物流</span>
                  <span v-show="a=='3'">联系客服</span>
              </div>
          </div>
          <!-- 弹窗 -->
          <div class='tipbox' v-show="tipbox=='1'">
            <!-- 取消订单弹窗 -->
            <div class="tip" v-show='two=="1"'>
              <p class="tipTitle">是否要取消订单？</p>
              <p class='tipbtnbox'><span class='close'>暂不取消</span><span class='tipbtn'>确认取消</span></p>
            </div>
            <!-- 客服电话弹窗 -->
            <div class="phone">
              <p class="title">客服电话 010-3687201</p>
              <p class="time">工作日时间：周一至周五9:00-18:00</p>
              <p class="phoneBtn">拨打客服电话</p>
            </div>
          </div>   
          <!--没有订单，占位符  -->
          <div class='kong' v-if="list== undefined  ||  list.length <= 0">
            <img class="kongpic" src="../../assets/img/shoppingMall/orderListkong.png" alt="">
            <p>你还没有相关的订单</p>
          </div>
      </div> 
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import Swiper from "swiper";
import { Loadmore } from 'mint-ui';
import toastDownloadPage from '../commen/toastDownloadPage'
import cbct from '../../assets/js/common/base.js';
export default {
  name: 'getTopic',
  data:function(){
    return{
      list:[
        {
          name:'1',
          img:'2',
        }
      ],
      a:'1',
      b:'1',
      tipbox:'1',
      two:'0',
    }
  },

  methods:{
  
    wechatBuy:function(){
        var self = this;
        self.http.post(this.cbct.https()+'/h5/channel/account/beans-transfer-charge', this.qs.stringify({
          amount:Number(this.realmoney*100)
          })).then((response)=>{
            if(response.c == this.cbct.code.successRes){
             
           
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                self.$router.push({path:'./register?returnUrl=convertPage?Truechnnel_id='+this.$route.query.Truechnnel_id });
            }else{
               Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }
            
        }
        ).catch((error)=>{console.log(error);})


    },
  },
  created(){
    //判断是否授权
    if(this.cbct.getCookie('openId') == undefined ||this.cbct.getCookie('openId') == ''){
        this.$router.push({path:'./change?channel_id='+this.$route.query.Truechnnel_id});
    }
    this.timing.time();
    $('title').html('我的订单');
  },
  mounted(){
   
  },
  components:{

  }
  
}


</script>
<style scoped lang="scss">
  .getTopic{
    width: 100%;
    height: 100%;
    .getTopicbox{
      margin: .2rem .3rem 0;
      height: 100%;
      position: relative;
      .kong{
        width: 100%;
        height: 100%;
        justify-content: center;
        .kongpic{
          width: 1.2rem;
          height: 1.2rem;
          margin-top: 4.4rem;
        }
        p{
          font-size: .24rem;
          margin-top: .2rem;
          color: rgba($color: #000000, $alpha: .8)
        }
      }
      .box{
        width:100%;
        height: 4rem;
        background: #fff;
        margin-bottom: .2rem;
        border-radius: .1rem;
        .title{
          color: #FC404A;
          text-align: right;
          font-size: .3rem;
          height: .84rem;
          line-height: .84rem;
          margin-right: .3rem;
          font-weight: 500;
        }
        .center{
          font-size: .26rem;
          color:#000;
          display: flex;
          margin: 0 .2rem;
          .left{
            width:1.8rem;
            height: auto;
            img{
              width:1.8rem;
              height: 1.8rem;
              border-radius: .16rem;
              border: 0.01rem solid rgba($color: #000000, $alpha: .1)
            }
          }
          .right{
            margin-left:.2rem;
            text-align: left; 
            .rightbox{
              height: 1.8rem;
              .rightTitle{
                line-clamp: 2;
                white-space:wrap;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                line-height: .36rem;
              }
              .rightText{
                font-size: .2rem;
                line-height: .28rem;
                margin-top: .15rem;
                line-clamp: 2;
                white-space:wrap;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                color: rgba($color: #000000, $alpha: .5);
              }
            }
            .numberbox{
               color: rgba($color: #000000, $alpha: .5);
               font-size: .2rem;
               height: .4rem;
               line-height: .4rem;
               .price{
                 float: right;
                 font{
                   font-size: .3rem;
                   color: #000;
                   float: right;
                   margin-left: .2rem;
                 }
               }
            }
          }
        }
        .btnBox{
          display: flex;
          margin: .2rem .2rem 0 0;
          overflow: hidden;
          float: right;
          .payment{
            background: #FC404A;
            color: #fff;
          }
          span{
            width: 1.52rem;
            height: .54rem;
            border: 1px solid rgba($color: #000000, $alpha: .2);
            line-height: .54rem;
            font-size: .24rem;
            color: rgba($color: #000000, $alpha: .59);
            border-radius: .4rem;
            margin-left: .2rem;
          }
        }
      }
      .tipbox{
        position: fixed;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background:rgba(3,3,3,0.5);
        overflow: hidden;
        .tip{
          width: 6rem;
          height: 2.9rem;
          border-radius: .16rem;
          background: #fff;
          margin: 4rem auto 0;
          box-sizing: border-box;
          .tipTitle{
            width: 100%;
            font-size:.34rem;
            color: #333;
            height: 1.84rem;
            line-height: 1.84rem;
            font-weight: 600;
            border-bottom: 1px solid rgba($color: #000000, $alpha: .2)
          }
          .tipbtnbox{
            display: flex;
            overflow: hidden;
            span{
              display: inline-block;
              width:3rem;
              font-size: .32rem;
              height: 1.03rem;
              line-height: 1.03rem;
            }
            .close{
              color: rgba($color: #000000, $alpha: .5);
              border-right: 1px solid rgba($color: #000000, $alpha: .2);
            }
            .tipbtn{
              color: #4473E1;
            }
          }
        }
        .phone{
          width: 6rem;
          height: 3.68rem;
          border-radius: .16rem;
          background: #fff;
          margin: 3.5rem auto 0;
          box-sizing: border-box;
          display: block;
          overflow: hidden;
          .title{
           
            font-size: .34rem;
            color: #333;
            margin: .76rem auto .32rem;
            line-height: .48rem;
          }
          .time{
            font-size:.32rem;
            color: rgba($color: #000000, $alpha: .5);
            margin-bottom: .68rem;
            line-height: .44rem;
          }
          .phoneBtn{
            font-size: .32rem;
            color: #4473E1;
            padding: .3rem;
            font-weight: 600;
            border-top:1px solid rgba($color: #000000, $alpha: .2);
          }
        }
      }
    }
 }
</style>

